import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { router } from '@/router';
import { theme } from '@/theme';
import { BootstrapGate } from '@/components/BootstrapGate';
// Self-hosted fonts (Roboto / Roboto Mono / Material Symbols Outlined).
import '@/theme/fonts';
// Locale catalogs + cookie — must load before the first paint.
import '@/i18n/i18n';

// Entry point — mounts the provider tree (theme, bootstrap, router). BootstrapGate
// sits above the router so tenant `authOrigin` / `loginUrl` exist before AuthGate
// or `/auth/return` run. The cold-start silent refresh + centralized-login
// redirect still run inside AuthGate (router-mounted) and wrap only the
// protected routes. The AuthProvider is mounted by RootLayout. See
// BootstrapGate.tsx, AuthGate.tsx, and the HANDOFF §3.5 boot/refresh contract.
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    {/* ThemeProvider + CssBaseline wrap the whole tree — both the public auth
        routes and the gated app shell render under the theme. */}
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BootstrapGate>
        <RouterProvider router={router} />
      </BootstrapGate>
    </ThemeProvider>
  </StrictMode>,
);
